module.exports = __webpack_public_path__ + "media/cat-adu.fd76c6b0.mp4";